import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import { Row, Col, Form, Label, Button } from "reactstrap";

const Declaration = ({ setSteps, setFormdata, formdata }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = (data) => {
        const selectedObjects = [];
        if (data.laptop) selectedObjects.push("Laptop");
        if (data.reloj) selectedObjects.push("Reloj");
        if (data.dinero) selectedObjects.push("Dinero");
        const object_declaration = selectedObjects.join(", ") + (data.itemsName ? `, ${data.itemsName}` : "");

        setFormdata((prev) => ({ ...prev, object_declaration,car_type:data.car_type }));
        setSteps((prev) => prev + 1);
    };

    const onBack = () => {
        setSteps((prev) => prev - 1);
    };

    return (
        <Fragment>
            <Row>
                <Col sm="12">
                    <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
                        <div className="dflex">
                            <Col md="12 mb-3">
                                <Label className="form-label">Tipo de Vehiculo</Label>
                                <div>
                                    <select name="car_type" className="form-select" {...register("car_type")}>
                                        <option value="hatchback">Hatchback</option>
                                        <option value="sedan">Sedan</option>
                                        <option value="suv">Camioneta</option>
                                    </select>
                                </div>
                            </Col>
                            <Col md="12 mb-3">
                                <Label className="form-label">Objetos de Valor</Label>
                                <div>
                                    <input type="checkbox" name="laptop" {...register("laptop")} />
                                    <Label className="form-check-label">Laptop</Label>
                                </div>
                                <div>
                                    <input type="checkbox" name="reloj" {...register("reloj")} />
                                    <Label className="form-check-label">Reloj</Label>
                                </div>
                                <div>
                                    <input type="checkbox" name="dinero" {...register("dinero")} />
                                    <Label className="form-check-label">Dinero</Label>
                                </div>
                            </Col>
                            <Col md="12 mb-3">
                                <Label className="form-label">Otros:</Label>
                                <input
                                    className="form-control"
                                    name="itemsName"
                                    type="text"
                                    placeholder="Otros"
                                    {...register("itemsName")}
                                />
                                <div className="valid-feedback">{"Looks good!"}</div>
                            </Col>
                            <div className="text-end btn-mb">
                                <Button type="submit" className="primary">Siguiente</Button>
                                <Button type="button" className="primary" onClick={onBack}>Anterior</Button>
                            </div>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Fragment>
    );
};

export default Declaration;
